import { MenuT } from 'types/frontend/Menu';
import { MyDate } from 'utils/shared/MyDate';

// 나중에 다국어 함수로 대체
const t = (str: string) => str;

const managementMenuRootPath = '/teacherSide/management';

const managementMenu: MenuT = [
  {
    title: t('관리도구'),
    items: [
      {
        title: t('학생 관리'),
        path: `${managementMenuRootPath}/student/list`,
      },
      {
        title: t('교사 관리'),
        path: `${managementMenuRootPath}/teacher/list`,
        accessablePositions: ['director', 'assistantDirector'],
      },
      {
        title: t('클래스 관리'),
        path: `${managementMenuRootPath}/cls/list`,
      },
      {
        title: t('원 정보'),
        path: `${managementMenuRootPath}/academy/detail`,
      },
    ],
  },
  {
    title: t('업무'),
    items: [
      {
        title: t('대시보드'),
        path: `${managementMenuRootPath}/dashboard`,
        accessablePositions: ['director', 'assistantDirector'],
      },
      {
        title: t('작업실'),
        path: `${managementMenuRootPath}/workroom`,
        accessablePositions: ['director', 'assistantDirector'],
        newUntil: MyDate.fromNumber(20250315),
      },
    ],
  },
  {
    title: t('초대'),
    items: [
      {
        title: t('학부모/학생 초대'),
        path: `${managementMenuRootPath}/invitationMessage`,
        accessablePositions: ['director', 'assistantDirector'],
      },
    ],
  },
];

export { managementMenu };
